import { faCog } from "@fortawesome/free-solid-svg-icons"
import React, { useState,useEffect } from "react";
import _ from 'lodash';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
// import styled from "styled-components";
import './index.scss';
import { getFromLS } from "../../../utils/storage";
import { useTheme } from "../../../hooks/useTheme";
const Themepicker = (props) =>{
        
    const themesFromStore = getFromLS('all-theme');
    // eslint-disable-next-line
    const [data, setData] = useState(themesFromStore.data);
    const [themes, setThemes] = useState([]);
    const [themeOpen,setThemeOpen]=useState(false);
    const {setMode} = useTheme();
    useEffect(() => {
        setThemes(_.keys(data));
        
    }, [data]);

    const themeSwitcher = selectedTheme => {
        // console.log(selectedTheme);
        setMode(selectedTheme);
        props.setter(selectedTheme);
    };

    const themeButtonClick=()=>{
        setThemeOpen(!themeOpen)
        // console.log(themeOpen?'Opened':'Closed');
        // console.log(data);
    }

    const ThemeCard = props => {
        return(
            <li className="wrapper" style={{backgroundColor: `${data[_.camelCase(props.theme.name)].colors.body}`, 
                     
                    fontFamily: `${data[_.camelCase(props.theme.name)].font}`}}>
                    
                <button className="themedbutton" onClick={ (theme) => themeSwitcher(props.theme) }
                    style={{backgroundColor: `${data[_.camelCase(props.theme.name)].colors.button.background}`, 
                    color: `${data[_.camelCase(props.theme.name)].colors.button.text}`,
                    fontFamily: `${data[_.camelCase(props.theme.name)].font}`}}>
                    {props.theme.name}
                </button>
            </li>
        )
    }
    
    return(
        <>
            <button className='theme-picker' onClick={themeButtonClick}>
                <span>
                    <FontAwesomeIcon icon={faCog}/>   
                </span> 
            </button>
            <div className={themeOpen?'cards-visible':'cards-invisible'}>
                <h2>Select the theme below.</h2>
                <ul className="theme-container">
                {
                themes.length > 0 && 
                    themes.map(theme =>(
                        <ThemeCard theme={data[theme]} key={data[theme].id} />
                    ))
                }
                </ul>
            </div>

        </>
    )
}

export default Themepicker